import { FaFacebook, FaTwitter } from 'react-icons/fa';
import styled from 'styled-components';

export const Facebook = styled(FaFacebook)`
  color: #4267b2;
  font-size: 30px;
`;

export const Twitter = styled(FaTwitter)`
  color: #1da1f2;
  font-size: 30px;
`;

export const StyledPhotosDiv = styled.div.attrs(() => ({
  className: 'flex items-center h-100',
}))``;

export const MainDiv = styled.div.attrs(() => ({
  className: 'container',
}))`
  height: 600px;
`;

export const SecondaryDiv = styled.div.attrs(() => ({
  className: 'position-absolute photo-css',
}))`
   
`;

export const StyledImg = styled.img.attrs(() => ({
  alt: 'area',
}))`
  width: 100%;
  border: 0;
  margin: 0;
  max-height: 550px;
  object-fit: contain;
  background: white;
`;

export const StyledImageDiv = styled.div.attrs(() => ({
  className: 'd-flex flex-row justify-center flex-nowrap mt-3',
}))``;
